import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';
import { TITLE_RULE } from '@constants';

export const FORM_FIELD = {
  AUDIENCE: {
    name: 'audience',
    label: 'Audience:',
    rules: [{ required: true, message: 'This field is required' }],
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  SEGMENT: {
    name: 'segment',
    label: 'Segment:',
    rules: [{ required: true, message: 'This field is required' }],
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  EVENT: {
    name: 'event',
    label: 'Related event:',
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  HEADER_IMAGE: {
    name: 'headerImage',
    label: 'Email header image:',
    size: IMAGE_SIZE['600x400'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  TITLE: {
    name: 'title',
    label: 'Email title:',
    rules: [{ required: true, message: 'Title is required' }, TITLE_RULE],
  },
  TEXT: {
    name: 'text',
    label: 'Email text:',
    rules: [{ required: true, message: 'Text is required' }],
  },
  CONTENT_MODULES: {
    name: 'contentModules',
    preset: 'emails',
    deserialize: (field, values) => ({
      [field.name]: values[field.name] || [],
    }),
  },
};
